import { CircularProgress, Stack } from '@mui/material';
import { Timer } from '@/components/timer/Timer';
import BodyRegular from '@/components/typography/BodyRegular';
import UntilTimeToSendOtp from '@/components/timer/UntilTimeToSendOtp';
import LoadingButton from '@/components/LoadingButton';
type Props = {
  handleSendOtp: () => void;
  onDone: () => void;
  otpTimeout: number | string;
  loading: boolean;
  isFirstTime: boolean;
  isFinished: boolean;
  sendOtpDisabled?: boolean;
};
const OtpTimer = ({
  handleSendOtp,
  otpTimeout,
  onDone,
  loading,
  isFirstTime,
  sendOtpDisabled = false
}: Props) => {
  return <Stack direction='row' justifyContent='center' alignItems='center' gap='var(--spacing_s)' height={36} data-sentry-element="Stack" data-sentry-component="OtpTimer" data-sentry-source-file="OtpTimer.tsx">
      <Timer time={new Date(+otpTimeout).toString()} onDone={onDone} data-sentry-element="Timer" data-sentry-source-file="OtpTimer.tsx">
        {({
        seconds,
        minutes
      }) => {
        const isLoading = loading || seconds === '-' && isFirstTime;
        if (isLoading) {
          return <BodyRegular textAlign='center'>
                <CircularProgress size={13} />
              </BodyRegular>;
        } else if (seconds && +seconds >= 0 || minutes && +minutes > 0) {
          return <UntilTimeToSendOtp seconds={seconds} minutes={minutes} />;
        } else {
          return <>
                <BodyRegular>کد را دریافت نکردید؟</BodyRegular>
                <LoadingButton size='small' onClick={handleSendOtp} sx={{
              fontSize: 'small'
            }} loading={loading} disabled={sendOtpDisabled}>
                  ارسال مجدد
                </LoadingButton>
              </>;
        }
      }}
      </Timer>
    </Stack>;
};
export default OtpTimer;